<div class="toast-stack" data-testid="toast-stack">
  <frodo-custom-snackbar
    *ngFor="let toast of toasts; trackBy: trackById"
    class="toast-stack__item"
    [message]="toast.message"
    [snackType]="toast.snackType"
    (click)="dismiss(toast.id)"
  ></frodo-custom-snackbar>
</div>
